import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  loadingWheel: {
    boxShadow: 'none'
  }
}));

export default useStyles;
